module.exports = __webpack_public_path__ + "img/281.ef5da3f7.png";